import ParentPermissionsPage from './../pages/ParentPermissionsPage.vue';

export default [
  {
    component: ParentPermissionsPage,
    path: '/permissions',
    name: 'ParentPermissionsPage',
    meta: {
      title: 'Permissions',
    },
  },
];
